<template>

  <div class="user">
    <!--筛选-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="会议名称">
          <el-input placeholder="请输入会议名称" v-model="formInline.name" style="width: 180px;"></el-input>
        </el-form-item> -->
        <el-form-item label="所属组织">
          <el-select v-model="formInline.affiliated_organization" placeholder="请选择所属组织" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in organizationList" :key="item.ma_organization_id" :label="item.name" :value="item.ma_organization_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议分类">
          <el-select v-model="formInline.meeting_category" placeholder="请选择会议分类" clearable style="width: 180px;">
            <el-option label="所有" value=""></el-option>
            <el-option v-for="item in conferenceClassificationList" :key="item.ma_conference_classification_id" :label="item.name" :value="item.ma_conference_classification_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会议时间">
          <el-date-picker
            v-model="formInline.meeting_time_range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="会议名称" width="200"></el-table-column>
            <el-table-column prop="affiliated_organization" label="所属组织" width="120"></el-table-column>
            <el-table-column prop="meeting_category" label="会议分类" width="120"></el-table-column>
            <el-table-column prop="meeting_introduction" label="会议简介" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="meeting_host" label="会议主持人" width="100"></el-table-column>
            <el-table-column prop="meeting_recorder" label="会议记录人" width="100"></el-table-column>
            <el-table-column prop="meeting_time" label="会议时间" width="160"></el-table-column>
            <el-table-column prop="meeting_place" label="会议地点" width="150"></el-table-column>
            <!-- <el-table-column prop="meeting_mode" label="会议模式" width="100"></el-table-column> -->
            <!-- <el-table-column prop="participants" label="参会人员" width="200" show-overflow-tooltip></el-table-column> -->
            <!-- <el-table-column prop="sort" label="排序" width="80"></el-table-column> -->
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="250">
              <template slot-scope="scope">
                <el-button @click="viewDetail(scope.row)" type="text" size="small">查看详情</el-button>
                <el-button @click="manageCheckIn(scope.row)" type="text" size="small">签到人员</el-button>
                <el-button @click="manageCheckOut(scope.row)" type="text" size="small">签退人员</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--会议详情弹窗-->
    <el-dialog title="会议详情" :visible.sync="detailDialogVisible" width="70%" @close="closeDetailDialog">
      <div class="meeting-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="会议名称">{{ currentMeeting.name }}</el-descriptions-item>
          <el-descriptions-item label="所属组织">{{ currentMeeting.affiliated_organization }}</el-descriptions-item>
          <el-descriptions-item label="会议分类">{{ currentMeeting.meeting_category }}</el-descriptions-item>
          <el-descriptions-item label="会议简介">{{ currentMeeting.meeting_introduction }}</el-descriptions-item>
          <el-descriptions-item label="会议主持人">{{ currentMeeting.meeting_host }}</el-descriptions-item>
          <el-descriptions-item label="会议记录人">{{ currentMeeting.meeting_recorder }}</el-descriptions-item>
          <el-descriptions-item label="会议时间">{{ currentMeeting.meeting_time }}</el-descriptions-item>
          <el-descriptions-item label="会议地点">{{ currentMeeting.meeting_place }}</el-descriptions-item>
          <el-descriptions-item label="会议模式">{{ currentMeeting.meeting_mode }}</el-descriptions-item>
          <el-descriptions-item label="会议周期">{{ currentMeeting.meeting_cycle }}</el-descriptions-item>
          <el-descriptions-item label="发布组织">{{ currentMeeting.publish_organization }}</el-descriptions-item>
          <el-descriptions-item label="会议标签">{{ currentMeeting.meeting_tags }}</el-descriptions-item>
          <el-descriptions-item label="参会人员">{{ currentMeeting.participants }}</el-descriptions-item>
          <el-descriptions-item label="会议内容">{{ currentMeeting.meeting_content }}</el-descriptions-item>
        </el-descriptions>
        
        <div class="meeting-files-section" v-if="currentMeeting.meeting_video && currentMeeting.meeting_video.length > 0">
          <h4>会议视频</h4>
          <div class="file-list">
            <video v-for="(video, index) in currentMeeting.meeting_video" :key="index" :src="video.file_path" controls style="width: 300px; height: 200px; margin-right: 10px;"></video>
          </div>
        </div>
        
        <div class="meeting-files-section" v-if="currentMeeting.meeting_document && currentMeeting.meeting_document.length > 0">
          <h4>会议文档</h4>
          <div class="file-list">
            <div v-for="(doc, index) in currentMeeting.meeting_document" :key="index" class="file-item">
              <i class="el-icon-document"></i>
              <span>{{ doc.name || '文档' }}</span>
              <a :href="doc.file_path" target="_blank" download>下载</a>
            </div>
          </div>
        </div>
        
        <div class="meeting-files-section" v-if="currentMeeting.meeting_image && currentMeeting.meeting_image.length > 0">
          <h4>会议图片</h4>
          <div class="image-list">
            <el-image v-for="(img, index) in currentMeeting.meeting_image" :key="index" :src="img.file_path" style="width: 150px; height: 150px; margin-right: 10px;" fit="cover"></el-image>
          </div>
        </div>
        
        <div class="meeting-files-section" v-if="currentMeeting.attachments && currentMeeting.attachments.length > 0">
          <h4>附件</h4>
          <div class="file-list">
            <div v-for="(file, index) in currentMeeting.attachments" :key="index" class="file-item">
              <i class="el-icon-document"></i>
              <span>{{ file.name || '文件' }}</span>
              <a :href="file.file_path" target="_blank" download>下载</a>
            </div>
          </div>
        </div>
        
        <div class="meeting-files-section" v-if="currentMeeting.attachment_images && currentMeeting.attachment_images.length > 0">
          <h4>附件图片</h4>
          <div class="image-list">
            <el-image v-for="(img, index) in currentMeeting.attachment_images" :key="index" :src="img.file_path" style="width: 150px; height: 150px; margin-right: 10px;" fit="cover"></el-image>
          </div>
        </div>
      </div>
    </el-dialog>

    <Edit :open_edit="open_edit" :ma_new_meeting_id="ma_new_meeting_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!--签到人员弹窗-->
    <CheckInPerson :open_check_in="open_check_in" :ma_new_meeting_id="ma_new_meeting_id" v-if="open_check_in" @close="closeCheckIn"></CheckInPerson>

    <!--签退人员弹窗-->
    <CheckOutPerson :open_check_out="open_check_out" :ma_new_meeting_id="ma_new_meeting_id" v-if="open_check_out" @close="closeCheckOut"></CheckOutPerson>

  </div>
</template>

<script>
import Ma_new_meetingApi from '@/api/ma_new_meeting.js';
import Ma_organizationApi from '@/api/ma_organization.js';
import Ma_conference_classificationApi from '@/api/ma_conference_classification.js';
import Edit from './part/edit.vue';
import CheckInPerson from './part/CheckInPerson.vue';
import CheckOutPerson from './part/CheckOutPerson.vue';

export default {
  components: {
    Edit,
    CheckInPerson,
    CheckOutPerson
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        name: "",
        affiliated_organization: "",
        meeting_category: "",
        meeting_time_range: []
      },
      organizationList: [],
      conferenceClassificationList: [],
      detailDialogVisible: false,
      open_edit: false,
      open_check_in: false,
      open_check_out: false,
      ma_new_meeting_id: "",
      currentMeeting: {}
    };
  },
  created() {
    this.loadOrganizations();
    this.loadConferenceClassifications();
    this.getTableList();
  },
  methods: {
    loadOrganizations() {
      let self = this;
      Ma_organizationApi.list({}, true)
          .then(data => {
            if (data.code === 1) {
              self.organizationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    loadConferenceClassifications() {
      let self = this;
      Ma_conference_classificationApi.list({}, true)
          .then(data => {
            if (data.code === 1) {
              self.conferenceClassificationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    resetSearch() {
      this.formInline = {
        name: "",
        affiliated_organization: "",
        meeting_category: "",
        meeting_time_range: []
      };
      this.curPage = 1;
      this.getTableList();
    },

    getData() {
      this.getTableList();
    },

    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;

      if (Params.meeting_time_range && Params.meeting_time_range.length === 2) {
        Params.meeting_time_start = Params.meeting_time_range[0];
        Params.meeting_time_end = Params.meeting_time_range[1];
      }
      delete Params.meeting_time_range;

      self.loading = true;
      Ma_new_meetingApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    viewDetail(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.loadMeetingDetail(row.ma_new_meeting_id);
      this.detailDialogVisible = true;
    },

    loadMeetingDetail(meetingId) {
      let self = this;
      Ma_new_meetingApi.detail({ ma_new_meeting_id: meetingId }, true)
          .then(data => {
            if (data.code === 1) {
              self.currentMeeting = data.data;
            }
          })
          .catch(error => {
          });
    },

    editClick(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.open_edit = true;
    },

    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_new_meetingApi.del(
                {
                  ma_new_meeting_id: row.ma_new_meeting_id
                },
                true
            )
                .then(data => {
                  if (data.code === 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('删除失败');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    },

    closeDetailDialog() {
      this.detailDialogVisible = false;
    },

    closeEdit() {
      this.open_edit = false;
      this.getTableList();
    },

    manageCheckIn(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.open_check_in = true;
    },

    manageCheckOut(row) {
      this.ma_new_meeting_id = row.ma_new_meeting_id;
      this.open_check_out = true;
    },

    closeCheckIn() {
      this.open_check_in = false;
    },

    closeCheckOut() {
      this.open_check_out = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 20px;
}

.common-seach-wrap {
  margin-bottom: 20px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.table-wrap {
  margin-top: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.meeting-detail {
  padding: 20px;
}

.meeting-files-section {
  margin-top: 30px;
  
  h4 {
    margin-bottom: 15px;
    font-size: 16px;
    color: #333;
  }
}

.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  
  .file-item {
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background: #f5f7fa;
    
    i {
      margin-right: 8px;
      font-size: 20px;
      color: #409eff;
    }
    
    span {
      flex: 1;
    }
    
    a {
      margin-left: 10px;
      color: #409eff;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_new_meeting/index/meeting_held.vue